module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"showMore":"Mehr","showLess":"Weniger","available":"Verfügbar"},"en":{"showMore":"Show more","showLess":"Show less","available":"Available"}}')
  delete Component.options._Ctor
}
